var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropertyTypeObject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43 -653)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 1,
    transform: "translate(43 653)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(49 662)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "HelveticaNeue-Medium,Helvetica Neue",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.42,
    y: 0
  }, "O")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyTypeObject);
export default __webpack_public_path__ + "static/media/propertyType-object.0c15b9df.svg";
export { ForwardRef as ReactComponent };